// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  effect,
  input,
  OnChanges,
  output,
  signal,
  SimpleChanges,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ApplicationInsightsService } from '../../portal/services/application-insights/application-insights-service/application-insights.service';

export type SparePartsTab = 'serviceTickets' | 'serviceParts';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-spare-parts-tabs',
  templateUrl: './spare-parts-tabs.component.html',
  styleUrl: './spare-parts-tabs.component.scss',
})
export class SparePartsTabsComponent implements OnChanges{
  countDisplay = input<string>('');
  selectedTab = input<SparePartsTab>('serviceTickets');
  tabChange = output<SparePartsTab>();
  
  protected readonly TAB_SERVICE_TICKETS: SparePartsTab = 'serviceTickets';
  protected readonly TAB_SERVICE_PARTS: SparePartsTab = 'serviceParts';

  protected readonly activeTab = signal<SparePartsTab>(this.selectedTab());
  protected readonly serviceTicketsActive = computed(
    () => this.TAB_SERVICE_TICKETS === this.activeTab(),
  );
  protected readonly servicePartsActive = computed(
    () => this.TAB_SERVICE_PARTS === this.activeTab(),
  );

  constructor(private applicationInsightsService: ApplicationInsightsService) {
    effect(() => this.tabChange.emit(this.activeTab()));
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTab']?.currentValue) {
      this.activeTab.set(this.selectedTab());
    }
  }

  onServiceTicketsClick(): void{
    this.activeTab.set(this.TAB_SERVICE_TICKETS);
    this.applicationInsightsService.trackComponentUsageEvent('ServiceTicketsTabOpened', {
      serviceType: 'serviceTickets'
    });
  }

  onServicePartsClick(): void{
    this.activeTab.set(this.TAB_SERVICE_PARTS);
    this.applicationInsightsService.trackComponentUsageEvent('ServicePartsTabOpened', {
      serviceType: 'serviceParts'
    });
  }
}
